import { createSlice } from "@reduxjs/toolkit";
import { getChatLogs } from "./thunk";

export interface IState {
  chatLogs: any;
  isChatLogLoading: boolean;
  isChatLogSuccess: boolean;

  error: any;
}

export const initialState: IState = {
  chatLogs: null,
  isChatLogLoading: false,
  isChatLogSuccess: false,

  error: {},
};

const ChatLogSlice = createSlice({
  name: "ChatLog",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //get Chat Log
    builder.addCase(getChatLogs.pending, (state: IState, action: any) => {
      state.isChatLogLoading = true;
    });
    builder.addCase(getChatLogs.fulfilled, (state: IState, action: any) => {
      state.chatLogs = action.payload.data;
      state.isChatLogSuccess = true;
      state.isChatLogLoading = false;
    });
    builder.addCase(getChatLogs.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isChatLogSuccess = false;
      state.isChatLogLoading = false;
    });
  },
});


export default ChatLogSlice.reducer;
